/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout/index'

const knowledgeRouter = {
  path: '',
  component: Layout,
  redirect: '/home',
  name: 'Knowledge',
  meta: {title: 'router.knowledge'},
  children: [
    {
      path: 'projects',
      component: () => import('@/views/knowledge/wiki.vue'), // Parent router-view
      name: 'Projects',
      meta: {
        title: 'router.knowledge'
      }
    },
    {
      path: 'projects/space/:uniq_code',
      component: () => import('@/views/knowledge/knowledge_manage.vue'), // Parent router-view
      name: 'ProjectsSpaceManage',
      meta: {
        title: 'router.knowledge-manage'
      }
    },
    {
      path: 'projects/:doc_uniq_code/:share_code?',
      component: () => import('@/views/knowledge/knowledge_manage.vue'), // Parent router-view
      name: 'KnowledgeManage',
      meta: {
        title: 'router.knowledge-manage'
      }
    }

  ]
}
export default knowledgeRouter
